import { SenzorCapabilities, WritableFeature } from '../api/JsdhNotifikaceService/generated/models/Iot';

/**
 * Zjisti zda senzor ma danou capability (writable property).
 */
export function hasCapability(caps: SenzorCapabilities | null | undefined, name: string): boolean {
    if (!caps?.capabilitiesSummary) return false;
    return caps.capabilitiesSummary.split(',').includes(name);
}

/**
 * Zjisti zda senzor ma sirenu (warning nebo alarm capability).
 */
export function hasSiren(caps: SenzorCapabilities | null | undefined): boolean {
    return hasCapability(caps, 'warning') || hasCapability(caps, 'alarm');
}

/**
 * Zjisti zda senzor ma funkcni sirenu (ma capability + neni disabled).
 */
export function hasWorkingSiren(caps: SenzorCapabilities | null | undefined): boolean {
    if (!caps) return false;
    if (caps.sirenaDisabled) return false;
    return hasSiren(caps);
}

/**
 * Parsuje writable features z JSON stringu.
 */
export function parseWritableFeatures(caps: SenzorCapabilities | null | undefined): WritableFeature[] {
    if (!caps?.writableFeatures) return [];
    try {
        return JSON.parse(caps.writableFeatures) as WritableFeature[];
    } catch {
        return [];
    }
}

/**
 * Najde konkretni feature podle property name.
 */
export function getFeature(
    caps: SenzorCapabilities | null | undefined,
    property: string
): WritableFeature | null {
    const features = parseWritableFeatures(caps);
    return features.find(f => f.property === property) ?? null;
}
